// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 789 ? "LoginPage" : chunkId) + "." + {"368":"85bca41c","789":"d2a84049"}[chunkId] + ".chunk.js";
};